(() => {
  function init() {
    if (!document.body.classList.contains('batch1101-v45')) return;
    const root=document.querySelector('product-info.fixed-product-ui');
    if(!root)return;
    const addClass=(selector,name)=>document.querySelectorAll(selector).forEach(el=>el.classList.add(name));
    addClass('.announcement-bar','fixed-ui-announcement');
    addClass('header.header','fixed-ui-nav-row');
    addClass('.header__heading-link','fixed-ui-nav-logo');
    addClass('.header__inline-menu','fixed-ui-nav-links');
    addClass('.header__icon','fixed-ui-icon-button');
    addClass('header-drawer summary','fixed-ui-mobile-menu');
    addClass('footer.footer','fixed-ui-footer');
    addClass('.product__media img','fixed-ui-main-image');
    addClass('.thumbnail-list','fixed-ui-thumbnails');
    addClass('.product-form__buttons','fixed-ui-buy');
    addClass('.shopify-payment-button__more-options','fixed-ui-more-payments');
    const sections=[...document.querySelectorAll('#MainContent > .shopify-section')];
    let priorDetail=false,first=true;
    sections.forEach(s=>{
      if(!s.children.length){s.hidden=true;return;}
      s.classList.add('fixed-ui-section');
      const detail=!!s.querySelector('.batch1101-detail');
      const utility=!!s.querySelector('.batch1101-sticky');
      if(utility){s.classList.add('batch1101-utility');return;}
      if(!first && !(detail&&priorDetail))s.classList.add('fixed-ui-section--spaced');
      if(detail)s.classList.add('fixed-ui-detail-strip');
      s.querySelectorAll(':scope > .section, :scope > .color-scheme-1').forEach(x=>x.classList.add('fixed-ui-section-inner'));
      priorDetail=detail;first=false;
    });
    const radios=[...root.querySelectorAll('input[name="batch1101-bundle"]')];
    function syncQuantity() {
      const qty=root.querySelector('input[name="quantity"]');
      const selected=radios.find(r=>r.checked);if(!selected||!qty)return;
      if(qty.value!==selected.value){qty.value=selected.value;qty.dispatchEvent(new Event('change',{bubbles:true}));}
      radios.forEach(r=>r.closest('label').classList.toggle('is-selected',r.checked));
    }
    radios.forEach(r=>r.addEventListener('change',syncQuantity));syncQuantity();
    root.addEventListener('submit',syncQuantity,true);
    const quantityRegion=root.querySelector('[id^="Quantity-Form-"]');
    if(quantityRegion)new MutationObserver(syncQuantity).observe(quantityRegion,{childList:true,subtree:true,attributes:true,attributeFilter:['min','max','data-cart-quantity','value']});
    document.querySelectorAll('.fixed-ui-faq').forEach(f=>f.addEventListener('toggle',e=>{
      if(e.target.tagName==='DETAILS'&&e.target.open) f.querySelectorAll('details').forEach(d=>{if(d!==e.target)d.open=false;});
    },true));
    const checkpoints=root.querySelector('[data-store-timezone]');
    if(checkpoints){
      const today=new Intl.DateTimeFormat('en-CA',{timeZone:checkpoints.dataset.storeTimezone,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const part=t=>today.find(p=>p.type===t).value;
      const date=new Date(Date.UTC(+part('year'),+part('month')-1,+part('day'),12));
      const format=n=>{const d=new Date(date);d.setUTCDate(d.getUTCDate()+n);return new Intl.DateTimeFormat('en-US',{timeZone:'UTC',month:'short',day:'numeric'}).format(d)};
      checkpoints.querySelectorAll('[data-delivery-date]').forEach(el=>{const [a,b]=el.dataset.deliveryDate.split(',').map(Number);el.textContent=format(a)+(a===b?'':' – '+format(b));});
    }
    const sticky=document.querySelector('.batch1101-sticky');
    const nativeAdd=root.querySelector('button[name="add"]');
    if(sticky&&nativeAdd){
      sticky.querySelector('button').addEventListener('click',()=>{if(!nativeAdd.disabled)nativeAdd.click()});
      new IntersectionObserver(entries=>{
        const entry=entries[0];const visible=!entry.isIntersecting&&entry.boundingClientRect.bottom<0;
        sticky.hidden=!visible;document.body.style.setProperty('--fixed-sticky-height',visible?sticky.offsetHeight+'px':'0px');
      }).observe(nativeAdd);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
